//Imports node_modules
import React, { useContext } from 'react'
import { CSSTransition } from 'react-transition-group';
import Modal from 'react-modal';


//Imports Css
import './LoadingModal.css'

//Imports Components

//Import Data
import { globalModals } from '../../../../data/GlobalModals'


//Layout de navegação na parte inferior da aplicação
const LoadingModal = (params) => {

    const {
        loadingModalStatus,
    } = useContext(globalModals)

    return (
        <div>
            <CSSTransition
                in={loadingModalStatus}
                timeout={300}
                classNames="dialog"
            >
                <Modal
                    closeTimeoutMS={360}
                    isOpen={loadingModalStatus}
                    className="Modal"
                    overlayClassName="Overlay"
                    disableAutoFocus={true}>
                    <div className="savingContent">
                        <div className="saving">
                            <div>
                                <div className="loading">
                                    <div style={{ marginLeft: '4px', marginTop: '11px' }}>
                                        <i style={{ fontSize: '60px', color: '#545756' }} className="fa fa-cogs" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </CSSTransition>
        </div>
    )
}
export default LoadingModal